var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "summary-container" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "subtotal-container" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Subtotal")]),
        _vm._v(" "),
        _c("p", { staticClass: "price" }, [
          _vm._v(_vm._s(_vm._f("intToDecimalPrice")(_vm.subtotal)))
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.lineItems, function(item) {
        return _c("div", { key: item.key, staticClass: "item-summary" }, [
          _c("p", { staticClass: "item-title" }, [_vm._v(_vm._s(item.title))]),
          _vm._v(" "),
          _c("div", { staticClass: "box-total" }, [
            _c("div", { staticClass: "total-container" }, [
              item.quantity > 1
                ? _c("p", { staticClass: "title" }, [
                    _c("strong", [_vm._v("(" + _vm._s(item.quantity) + ")")]),
                    _vm._v(" boxes")
                  ])
                : _c("p", { staticClass: "title" }, [
                    _c("strong", [_vm._v("(" + _vm._s(item.quantity) + ")")]),
                    _vm._v(" box")
                  ]),
              _vm._v(" "),
              item.isBundle
                ? _c("p", { staticClass: "price" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("intToDecimalPrice")(
                          (item.totalPrice / 100 -
                            _vm.boxPrice * item.quantity -
                            _vm.feePrice * item.quantity -
                            _vm.cardPrice * item.quantity) *
                            100
                        )
                      )
                    )
                  ])
                : _c("p", { staticClass: "price" }, [
                    _vm._v(_vm._s(_vm._f("intToDecimalPrice")(item.totalPrice)))
                  ])
            ]),
            _vm._v(" "),
            item.isBundle
              ? _c("p", { staticClass: "individual-price" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("intToDecimalPrice")(
                        (item.individualPrice / 100 -
                          _vm.boxPrice -
                          _vm.feePrice -
                          _vm.cardPrice) *
                          100
                      )
                    ) + " per box"
                  )
                ])
              : _c("p", { staticClass: "individual-price" }, [
                  _vm._v(
                    _vm._s(_vm._f("intToDecimalPrice")(item.individualPrice)) +
                      " per box"
                  )
                ])
          ]),
          _vm._v(" "),
          item.isBundle
            ? _c("div", { staticClass: "box-total" }, [
                _c("div", { staticClass: "total-container" }, [
                  _c("p", { staticClass: "title service-fee" }, [
                    _c("strong", [_vm._v("(" + _vm._s(item.quantity) + ")")]),
                    _vm._v(" Service Fee "),
                    _c("img", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: {
                            content:
                              "This fee covers the labor to hand write your card (if applicable!) and hand pack your box beautifully!",
                            container: false,
                            hideOnTargetClick: false
                          },
                          expression:
                            "{content: 'This fee covers the labor to hand write your card (if applicable!) and hand pack your box beautifully!', container:false,hideOnTargetClick: false}"
                        }
                      ],
                      attrs: {
                        src:
                          "https://cdn.shopify.com/s/files/1/1363/8433/files/i_button.png?v=1589076588"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "price" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("intToDecimalPrice")(
                          _vm.feePrice * item.quantity * 100
                        )
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "individual-price" }, [
                  _vm._v(
                    _vm._s(_vm._f("moneySaleFormat")(_vm.feePrice)) + " per box"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          item.isBundle
            ? _c("div", { staticClass: "box-total" }, [
                _c("div", { staticClass: "total-container" }, [
                  item.quantity > 1
                    ? _c("p", { staticClass: "title" }, [
                        _c("strong", [
                          _vm._v("(" + _vm._s(item.quantity) + ")")
                        ]),
                        _vm._v(" Boxes")
                      ])
                    : _c("p", { staticClass: "title" }, [_vm._v("Box")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "price" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("intToDecimalPrice")(
                          _vm.boxPrice * item.quantity * 100
                        )
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "individual-price" }, [
                  _vm._v(
                    _vm._s(_vm._f("moneySaleFormat")(_vm.boxPrice)) + " per box"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          item.isBundle
            ? _c("div", { staticClass: "box-total" }, [
                _c("div", { staticClass: "total-container" }, [
                  item.quantity > 1
                    ? _c("p", { staticClass: "title" }, [
                        _c("strong", [
                          _vm._v("(" + _vm._s(item.quantity) + ")")
                        ]),
                        _vm._v(" Cards")
                      ])
                    : _c("p", { staticClass: "title" }, [_vm._v("Card")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "price" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("intToDecimalPrice")(
                          _vm.cardPrice * item.quantity * 100
                        )
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "individual-price" }, [
                  _vm._v(
                    _vm._s(_vm._f("moneySaleFormat")(_vm.cardPrice)) +
                      " per box"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "box-total" }, [
            _c("div", { staticClass: "total-container" }, [
              _c("p", { staticClass: "title" }, [_vm._v("Estimated Shipping")]),
              _vm._v(" "),
              _c("p", { staticClass: "price" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("intToDecimalPrice")(
                      _vm.shippingPrice * item.quantity
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "individual-price" }, [
              _vm._v(
                _vm._s(_vm._f("intToDecimalPrice")(_vm.shippingPrice)) +
                  " per box"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-total" }, [
            _c("p", { staticClass: "title" }, [_vm._v("Item Total")]),
            _vm._v(" "),
            _c("p", { staticClass: "price" }, [
              _vm._v(
                _vm._s(
                  _vm._f("intToDecimalPrice")(
                    _vm.shippingPrice * item.quantity + item.totalPrice
                  )
                )
              )
            ])
          ])
        ])
      }),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2)
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button-checkout" }, [
      _c("p", { staticClass: "subtitle" }, [
        _vm._v(
          "Supply shipping address selections for each box in order to proceed to checkout."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "taxes-container" }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("Taxes"),
        _c("strong", [_vm._v(" (calculated in checkout)")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "price" }, [_vm._v("--")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "shipping-term-services" }, [
      _vm._v('\n      By clicking "Continue to check out" you agree to our '),
      _c("a", { attrs: { href: "/pages/terms-conditions" } }, [
        _vm._v("Terms of Service")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }